export const SHOULD_DISPLAY_ICON = false;
export const SHOULD_USE_SECONDARY_VARIANT = false;
export const POINTS_TRANSLATION_KEY = 'points';
export const ONLY_SHOW_REDEEM_REWARD_IN_RESTAURANT_CTA = 'onlyShowRedeemRewardInRestaurantCTA';
export const REDEEM_REWARD_TRANSLATION_KEY = 'redeemReward';
